import { render, staticRenderFns } from "./MercadoPagoSettings.vue?vue&type=template&id=5e795a9c"
import script from "./MercadoPagoSettings.vue?vue&type=script&lang=js"
export * from "./MercadoPagoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports